<template>
  <div class="gamelist_box">
    <div class="gamelist">
      <div class="condition">
        <div class="condition_select">
          <div class="condition_text">{{ $t("gamelist.state") }}</div>
          <div class="">
            <el-select
              class="aaaa"
              v-model="selectStatus"
              @change="changeSelect"
            >
              <el-option
                v-for="(item, index) in ArrSelect"
                :key="index"
                :label="item"
                :value="index"
              ></el-option>
            </el-select>
          </div>
          <router-link class="new_btn CU" tag="div" to="/FoundGame">
            <img class="set_img" src="@/img/set_img.png" alt="" />
            {{ $t("gamelist.addgame") }}
          </router-link>
        </div>
        <div class="seek_box">
          <div class="seek">
            <div class="seek_url">
              <img class="seek_img" src="@/img/seek.png" alt="" />
            </div>
            <div class="seek_input_box">
              <input
                @input="throttledHandleInput"
                v-model="searchText"
                :placeholder="$t('gamelist.gamename')"
                class="seek_input TGA_INPUT"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="gamelist_table">
        <a-config-provider>
          <template
            v-if="datalist.length <= 0 && !tableloading"
            #renderEmpty
            style=""
          >
            <div style="text-align: center; margin-top: 224px">
              <img src="@/img/kong.png" alt="" />
              <p>
                {{ $t("gamelist.began") }}
                <router-link
                  class="CU"
                  style="color: #4990fa"
                  tag="span"
                  to="/FoundGame"
                  >{{ $t("gamelist.create") }}</router-link
                >
                {{ $t("gamelist.creategame") }}
              </p>
            </div>
          </template>

          <template v-if="datalist.length <= 0 && tableloading" style="">
            <div style="text-align: center; margin-top: 224px">
              <loading></loading>
            </div>
          </template>

          <a-table
            :columns="columns"
            :data-source="datalist"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
            <template slot="id" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="name" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="status" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="version" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="updateTime" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="btn" slot-scope="text, record, index">
              <span style="margin-left: 10px">
                <router-link
                  :to="{
                    path: '/GameInfo',
                    query: { appId: record.appId, gameId: record.id },
                  }"
                  >{{ $t("gamelist.admi") }}</router-link
                >
              </span>

              <span
                style="margin-left: 10px"
                @click="UploadAction('down', record.id)"
                v-if="record.isEnabled == 1"
              >
                <a>{{ $t("gamelist.down") }}</a>
              </span>
              <span
                style="margin-left: 10px"
                @click="UploadAction('up', record.id)"
                v-if="record.isEnabled == 0"
              >
                <a>{{ $t("gamelist.up") }}</a>
              </span>
            </template>
          </a-table>
        </a-config-provider>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import loading from "@/components/loading/loading.vue";
import { throttle } from "lodash";

function NewData(data) {
  var d = new Date(data);
  var year = d.getFullYear(); //年
  var month = d.getMonth() + 1; //月
  var day = d.getDate(); //日
  var hh = d.getHours(); //时
  var mm = d.getMinutes(); //分
  var ss = d.getSeconds(); //秒
  var clock = year + "-";
  if (month < 10) clock += "0";
  clock += month + "-";
  if (day < 10) clock += "0";
  clock += day + " ";
  if (hh < 10) clock += "0";
  clock += hh + ":";
  if (mm < 10) clock += "0";
  clock += mm + ":";
  if (ss < 10) clock += "0";
  clock += ss;
  return clock;
}

export default {
  components: {
    loading,
  },
  data() {
    return {
      tableloading: true,
      selectStatus: 0,
      ArrSelect: this.$t("gamelist.arrSelect"),
      searchText: "",
      datalist: [],
      list: [],
      columns: [
        {
          title: this.$t("gamelist.gameId"),
          dataIndex: "id",
          key: "id",
          scopedSlots: { customRender: "id" },
          width: "25%",
        },
        {
          title: this.$t("gamelist.appName"),
          dataIndex: "name",
          key: "name",
          width: "25%",
          scopedSlots: { customRender: "name" },
          customRender: (text, record) => {
            var data = JSON.parse(text);
            var newtext = data.find(
              (item) => item.lang.toLowerCase() == this.$i18n.locale
            );
            if (!newtext) {
              return data[0].values;
            }
            return newtext.values;
          },
        },
        {
          title: this.$t("gamelist.version"),
          dataIndex: "version",
          key: "version",
          ellipsis: true,
          width: "10%",
          scopedSlots: { customRender: "version" },
          customRender: (text, record) => {
            var data = text;
            if (text == null) {
              data = this.$t("gamelist.kong");
            }
            return data;
          },
        },
        {
          title: this.$t("gamelist.checkState"),
          dataIndex: "status",
          key: "status",
          ellipsis: true,
          width: "10%",
          customRender: (text, record) => {
            var state = this.$t("gamelist.allstate");
            var data = state[text + 1];
            return data;
          },
        },
        {
          title: this.$t("gamelist.lastModified"),
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
          width: "15%",
          customRender: (text, record) => {
            var data = NewData(text);
            return data;
          },
        },
        {
          title: this.$t("gamelist.btn"),
          dataIndex: "btn",
          key: "btn",
          scopedSlots: { customRender: "btn" },
        },
      ],
      description: "add",
      pagination: {
        defaultCurrent: 1,
        total: 0,
        pageSize: 20,
      },
      current: 1,
      pageSize: 20,
    };
  },

  created() {
    if (localStorage.getItem("roleName") && localStorage.getItem("roleName").includes("APP_DEVELOPER")) {
      this.$router.push({
        path: "/app_management",
      });
    }
    this.getlist();
  },
  mounted() {
    this.throttledHandleInput = throttle(this.handleInput, 500);
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", ["AppList", "getGameList", "gameUp", "gameDown"]),

    async SendAction(action, gameId) {
      console.log("action", action);
      if (action == "up") {
        var res = await this.gameUp({
          $axios: this.$axios,
          id: gameId,
        });
        if (res.code == 200) {
          this.tipMessage({
            context: this.$t("gamelist.upSuccess"),
          });
          this.getlist();
        }
      } else {
        var res = await this.gameDown({
          $axios: this.$axios,
          id: gameId,
        });
        if (res.code == 200) {
          this.tipMessage({
            context: this.$t("gamelist.downSuccess"),
          });
          this.getlist();
        }
      }
    },

    // 上下架
    UploadAction(action, gameId) {
      var self = this;
      this.$confirm({
        title:
          action == "up" ? this.$t("gamelist.up") : this.$t("gamelist.down"),
        content:
          action == "up"
            ? this.$t("gamelist.isup")
            : this.$t("gamelist.isdown"),
        okText: this.$t("gamelist.ok"),
        cancelText: this.$t("gamelist.cancel"),
        onOk() {
          self.SendAction(action, gameId);
        },
        onCancel() {},
      });
    },

    handleTableChange(pagination, filters, sorter) {
      this.current = pagination.current;
      this.getlist();
    },
    // 点击查询
    send() {
      this.datalist = [];
      this.current = 1;
      this.getlist();
    },
    async getlist() {
      this.tableloading = true;
      var res = await this.getGameList({
        $axios: this.$axios,
        current: this.current,
        pageSize: this.pageSize,
      });
      if (res.code == 200) {
        this.tableloading = false;
        this.pagination.total = res.total;
        this.datalist = res.data;
      }
    },
    async changeSelect() {
      this.tableloading = true;
      this.datalist = [];
      this.current = 1;
      var res = await this.getGameList({
        $axios: this.$axios,
        current: this.current,
        pageSize: this.pageSize,
        status: this.selectStatus == 0 ? null : this.selectStatus - 2,
        name: this.searchText,
      });
      if (res.code == 200) {
        this.tableloading = false;
        this.pagination.total = res.total;
        this.datalist = res.data;
      }
    },
    // 模糊查询
    async handleInput() {
      this.tableloading = true;
      this.datalist = [];
      this.current = 1;
      var res = await this.getGameList({
        $axios: this.$axios,
        current: this.current,
        pageSize: this.pageSize,
        status: this.selectStatus == 0 ? null : this.selectStatus - 2,
        name: this.searchText,
      });
      if (res.code == 200) {
        this.tableloading = false;
        this.pagination.total = res.total;
        this.datalist = res.data;
      }
    },
  },
};
</script>

<style scoped="scoped">
.gamelist_box {
  margin: 59px auto;
  width: 1520px;
  height: 750px;
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.gamelist {
  width: 100%;
  height: 100%;
}
.condition {
  width: 1522px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 40px;
  background-color: #f5f7fa;
  border-bottom: solid 1px #e5e5e5;
  margin-bottom: 25px;
}
.condition_select {
  display: flex;
  align-items: center;
}
.condition_text {
  color: #666666;
  font-size: 14px;
  margin-right: 23px;
}
.new_btn {
  margin-left: 20px;
  width: 120px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}
.new_btn .set_img {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}
.gamelist_table {
  width: 100%;
  padding: 0 32px;
}
.seek_box {
  display: flex;
  align-items: center;
}

.seek {
  width: 421px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  /* border: solid 1px #e5e5e5; */
  display: flex;
  align-items: center;
  position: relative;
}

.seek_url {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  height: 100%;

  display: flex;
  align-items: center;
  padding: 0 13px;
}
.seek_img {
  width: 15px;
  height: 15px;
}
.seek_input_box {
  position: relative;
  width: 100%;
  height: 100%;
}
.seek_input {
  padding-left: 40px;
  width: 100%;
  height: 100%;
}
.seek_btn {
  width: 90px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  color: #666666;
  font-size: 14px;
  margin-left: 20px;
  text-align: center;
  line-height: 40px;
}

.gamelist_box .aaaa {
  width: 176px;
  color: rgb(28, 28, 28);
}
</style>



// WEBPACK FOOTER //
// src/components/game_management.vue